import { render, staticRenderFns } from "./AddZipCodes.vue?vue&type=template&id=ff229300&"
import script from "./AddZipCodes.vue?vue&type=script&lang=js&"
export * from "./AddZipCodes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports